import { render, staticRenderFns } from "./ManuscriptDownload.vue?vue&type=template&id=571bb431&scoped=true"
import script from "./ManuscriptDownload.vue?vue&type=script&lang=js"
export * from "./ManuscriptDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571bb431",
  null
  
)

export default component.exports